import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import MembershipChild from './MembershipChild';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '');

interface MembershipProps {
  open?: boolean;
  onCancel?: () => void;
  onConfirm?: (values: any) => void;
  currentPrice?: number;
  membershipType?: number;  // 会员类型
  isCarpoolService?: boolean;
  carpoolBiddingPrice?: number;
  isDriverCancellation?: boolean;
  carpoolOrderId?: string | number;
  carpoolBiddingId?: number;
}

const Membership: React.FC<MembershipProps> = ({ 
  open = false, 
  onCancel, 
  onConfirm, 
  currentPrice = 0,
  membershipType = 0,
  isCarpoolService = false,
  carpoolBiddingPrice = 0,
  isDriverCancellation = false,
  carpoolOrderId,
  carpoolBiddingId,
 }) => {
  return (
    <Elements stripe={stripePromise}>
      <MembershipChild 
      open={open}
      onCancel={onCancel} 
      onConfirm={onConfirm} 
      membershipType={membershipType} 
      isCarpoolService={isCarpoolService} 
      carpoolBiddingPrice={carpoolBiddingPrice} 
      isDriverCancellation={isDriverCancellation}
      carpoolOrderId={carpoolOrderId}
      carpoolBiddingId={carpoolBiddingId}
      />
    </Elements>
  );
};

export default Membership;
